import { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import { WrapperCreate } from './styles';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const Index = () => {
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  useEffect(() => {
    console.log(editorState);
  }, [editorState]);

  const [value, setValue] = useState();

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <WrapperCreate>
      <div className="w-full p-24">
        <div>
          <div className="flex mb-4 flex-col bg-white m-20 rounded-lg mt-0 p-10">
            <strong className="title-create">Crear Documento</strong>
          </div>
          <div className="flex p-10 w-full">
            <div className="w-1/4 flex-col bg-white m-10 rounded-lg mt-0 p-10">
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                De:
              </InputLabel>
              <TextField
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="email_repository"
                value="saul.franco@vantilabs.com"
                fullWidth
                style={{
                  width: '98%',
                  margin: '2% 2% 2% 0%',
                }}
                disabled
              />
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Para:
              </InputLabel>
              <TextField
                id="outlined-basic"
                label="Ingrese el email"
                variant="outlined"
                type="text"
                name="email_repository"
                // value={}
                fullWidth
                style={{
                  width: '98%',
                  margin: '2% 2% 2% 0%',
                }}
              />
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Fecha:
              </InputLabel>
              <DesktopDatePicker
                value={value}
                onChange={handleChange}
                renderInput={(params) => (
                  <TextField
                    style={{
                      width: '98%',
                      margin: '2% 2% 2% 0%',
                    }}
                    {...params}
                  />
                )}
                fullWidth
              />
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Status:
              </InputLabel>
              <FormControl
                style={{
                  width: '98%',
                  margin: '2% 2% 2% 0%',
                }}
              >
                <InputLabel htmlFor="my-input">Seleccione el status</InputLabel>
                <Select labelId="status" id="demo-simple-select" label="status">
                  <MenuItem value={1}>Privado</MenuItem>
                  <MenuItem value={2}>Público</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="w-3/4 flex-col bg-white m-10 rounded-lg mt-0 p-10" style={{ minHeight: '600px', maxHeight: '650px' }}>
              <Editor editorState={editorState} onEditorStateChange={setEditorState} />
            </div>
          </div>
          <div className="flex-col bg-white m-10 rounded-lg mt-0 p-5 button-create">
            <Button variant="contained" color="error" style={{ margin: '10px' }}>
              Cancelar
            </Button>
            <Button variant="contained" color="success" style={{ margin: '10px' }}>
              Publicar
            </Button>
          </div>
        </div>
      </div>
    </WrapperCreate>
  );
};

export default Index;
